import { Link } from "react-router-dom";
import { resolveNavLinks } from "../../lib/navUtils";

export default function Footer({ globals, whatsappNumber, navigation, uiStrings, enabledSections }) {
  const year = new Date().getFullYear();
  const whatsapp = whatsappNumber || globals?.whatsapp_number || "";
  const waDigits = whatsapp.replace(/\D/g, "");
  
  const logoText = globals?.logo || "Hub";
  const footerDesc = globals?.footer_description || "Consultoria imobiliária, consórcios, financiamento e design — sob curadoria refinada.";
  const contactEmail = globals?.contact_email || "emyprates@gmail.com";
  const locations = globals?.locations || "Lisboa · Porto · Online";
  const copyright = globals?.copyright || `Hub Profissional. Todos os direitos reservados.`;

  const navHeading = uiStrings?.footer?.nav_heading || "Navegação";
  const contactHeading = uiStrings?.footer?.contact_heading || "Contato";
  const adminLinkText = uiStrings?.footer?.admin_link || "Área restrita";
  const navLinks = resolveNavLinks(navigation, enabledSections);

  return (
    <footer data-testid="site-footer" className="bg-softblack text-fendi/80 pt-20 pb-10 grain relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-fendi/20">
          <div className="lg:col-span-5">
            <p className="font-serif text-3xl text-offwhite">{logoText}<span className="text-champagne">.</span></p>
            <p className="mt-6 max-w-md font-light leading-relaxed text-sm">
              {footerDesc}
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="eyebrow !text-champagne/80">{navHeading}</p>
            <ul className="mt-5 space-y-2 text-sm">
              {navLinks.map((link, i) => (
                <li key={i}><a className="link-underline" href={link.href}>{link.label}</a></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="eyebrow !text-champagne/80">{contactHeading}</p>
            <ul className="mt-5 space-y-2 text-sm">
              <li><a className="link-underline" href={`https://wa.me/${waDigits}`} target="_blank" rel="noopener noreferrer">{whatsapp}</a></li>
              <li><a className="link-underline" href={`mailto:${contactEmail}`}>{contactEmail}</a></li>
              <li>{locations}</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-fendi/60">
          <p>© {year} {copyright}</p>
        </div>
      </div>
    </footer>
  );
}
